import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { motion } from "framer-motion";
export default function FAQskillsphere({ faqs }) {
    return(<div>
        <div>
           {faqs?.map((faq, index) => (
  <Accordion 
  key={index} 
  sx={{ 
    mb: 2,
    '&.MuiAccordion-root': {
      minHeight: 80,
      backgroundColor: '#F8F9FA', // Off-white background
      borderRadius: '8px !important',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      transform: 'scale(1)',
      '&:hover': {
        backgroundColor: '#F1F3F5', // Slightly darker on hover
        transform: 'scale(1.02)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
      },
      '&.Mui-expanded': {
        backgroundColor: '#F8F9FA',
        margin: '16px 0 !important',
        transform: 'scale(1) !important',
      }
    }
  }}
>
  <AccordionSummary
    expandIcon={
      <ArrowDownwardIcon sx={{ 
        color: '#1976D2', // Blue in both states
        transition: 'transform 0.3s ease',
        '&.Mui-expanded': {
          transform: 'rotate(180deg)',
          color: '#1976D2' // Maintains blue when expanded
        }
      }} />
    }
    aria-controls={`panel${index}-content`}
    id={`panel${index}-header`}
    sx={{
      '&.Mui-expanded': {
        color: '#1976D2', // Blue color when expanded
        minHeight: 64,
      },
      '& .MuiAccordionSummary-content': {
        margin: '16px 0',
        transition: 'transform 0.2s ease',
      },
      minHeight: 64,
      padding: '0 16px',
      color: '#495057', // Dark gray text by default
      '&:hover .MuiAccordionSummary-content': {
        transform: 'translateX(4px)'
      }
    }}
  >
    <Typography 
      component="span" 
      fontWeight="semibold"
      sx={{
        fontFamily: "Montserrat",
        fontSize: 18,
        lineHeight: 1.5,
        padding: '8px 0',
        color: 'inherit',
        transition: 'color 0.2s ease',
        fontWeight:500
      }}
    >
      {faq.question}
    </Typography>
  </AccordionSummary>
  <AccordionDetails sx={{
    padding: '16px 24px',
    backgroundColor: '#FFFFFF', // White background for details
    borderRadius: '0 0 8px 8px',
    borderTop: '1px solid #E9ECEF',
    transition: 'all 0.3s ease-out',
    animation: 'fadeIn 0.3s ease-out',
    '@keyframes fadeIn': {
      '0%': { opacity: 0, transform: 'translateY(-10px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' }
    }
  }}>
    <Typography sx={{ 
      fontFamily: "Poppins",
      lineHeight: 1.6,
      color: '#495057' // Dark gray text
    }}>
      {faq.answer}
    </Typography>
  </AccordionDetails>
</Accordion>
           ))}
         </div>
    </div>)
}